import script from "./QFZCalculator.vue?vue&type=script&setup=true&lang=js"
export * from "./QFZCalculator.vue?vue&type=script&setup=true&lang=js"

import "./QFZCalculator.vue?vue&type=style&index=0&id=3e064e65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e064e65"]])

export default __exports__